export abstract class DataService {
    abstract getData(): string;
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./src/lib/datasource/shared/datasources/data.service.ts